import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from './Icon';
import { apiRequest } from '../../utils';

/* Bell + unread badge for the member pages. Polls the non-destructive count endpoint and links
   to the notifications feed, which marks everything read on open — so the badge clears once the
   member actually looks. Refreshes on mount and whenever the tab regains focus (no interval
   polling; a booking/membership rarely lands while the page is open). */
const NotificationBell = ({ className = '' }) => {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const d = await apiRequest('GET', '/notifications/count');
      setCount(Number(d && d.unread) || 0);
    } catch {
      /* silent — with no count the bell simply shows no badge */
    }
  }, []);

  useEffect(() => {
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onFocus);
    };
  }, [load]);

  return (
    <button
      type="button"
      className={`notif-bell ${className}`}
      onClick={() => navigate('/notifications')}
      aria-label="Notifications"
    >
      <Icon name="bell" />
      {count > 0 && (
        <span className="notif-bell__badge">{count > 9 ? '9+' : count}</span>
      )}
    </button>
  );
};

export default NotificationBell;
